<template lang="pug">
  v-card
    v-card-title
      h2.modal-title {{ 'auth.change_password' | translate }}
    v-card-content
      div
        v-text-field(
          :label="'auth.new_password' | translate"
          v-model="form.password")
        span.hint(
          v-if="showPasswordLengthHint")
          | (мінімальна довжина пароля 8 символів)
      v-text-field(
        :label="'auth.repite_password' | translate"
        v-model="form.password_repeat")
    v-card-actions
      v-btn(
        :disabled="!isPasswordValid"
        :loading="loading"
        @click="onSubmit")
        | {{ $t('base.change') }}
</template>

<script>
export default {
  name: 'ChangePassword',

  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },

  data: () => ({
    form: {
      password: null,
      password_repeat: null
    }
  }),

  computed: {
    showPasswordLengthHint () {
      return this.form.password &&
        this.form.password.length < 8
    },

    isPasswordValid () {
      return this.form.password &&
        this.form.password.length >= 8 &&
        this.form.password === this.form.password_repeat
    }
  },

  methods: {
    onSubmit () {
      const payload = {
        password: this.form.password
      }
      this.$emit('submit', payload)
    }
  }
}
</script>

<style scoped>
.v-card__title {
  padding: 2rem 2.4rem 1.6rem;
}

.modal-title {
  font-size: 2rem;
  font-weight: 700;
  margin: 0;
}

.v-card__content {
  border-top: .1rem solid #d7d7d7;
  padding-bottom: 1.5rem !important;
}

.v-card__actions {
  padding: 0 2.4rem 2.4rem;
}

.v-card__actions button {
  width: 100%;
}

.hint {
  opacity: .5;
  display: block;
  font-size: 12px;
  font-weight: 300;
  margin-bottom: 1rem;
}
</style>
